import { setupSentry } from '@sigma/nuxt-utils/setupSentry.js';

setupSentry();
